import React, { useState, useEffect } from "react";
import { Url, DYRUrl } from "../../Services/Api";
import "./style.css";
import axios from "axios";
import BottomToust from "../../Components/BottomToust/BottomToust";

export default function SubCategoriesDYR() {
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);
    const [editId, setEditId] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const [selectedMainCategories, setSelectedMainCategories] = useState(["686694202ac8d047299ea419"]);


    const fetchSelectedSubCategories = async () => {
        try {
            const response = await fetch(`${DYRUrl}/api/v1/sub-category/sub-categories`);
            const data = await response.json();
            console.log(data, "here")
            if (data && data.data) {
                setSelectedSubCategories(data.data);
            } else {
                console.error("No sub-categories found in the response data");
            }
        } catch (error) {
            console.error("Error fetching sub-categories:", error);
        }
    };


    /* --- Function to Get Categories via API Call and Update State By Using Hook --- */
    const fetchCategories = async () => {
        try {
            const response = await fetch(
                `${Url}/api/v1/productCategory/get`
            );
            const data = await response.json();

            if (!data || !data.categories) {
                console.error("No categories found in the response data");
                return;
            }

            const mainCategories = [];
            const subCategories = {};

            data.categories.forEach((category) => {
                if (category.parent === 0) {
                    mainCategories.push({
                        ...category,
                        subcategories: [],
                    });
                } else {
                    if (!subCategories[category.parent]) {
                        subCategories[category.parent] = [];
                    }
                    subCategories[category.parent].push(category);
                }
            });

            mainCategories.forEach((mainCategory) => {
                if (subCategories[mainCategory.uid]) {
                    mainCategory.subcategories = subCategories[mainCategory.uid];
                }
            });

            setCategories(mainCategories);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const [selectedCategory, setSelectedCategory] = useState(null);

    const renderSubcategories = (category) => {
        if (!category.subcategories || category.subcategories.length === 0)
            return null;

        return (
            <div className="subcategory-list">
                {category.subcategories.map((subcategory) => (
                    <div className="subcategory-item" key={subcategory.uid}>
                        <input
                            type="checkbox"
                            disabled={false}
                            id={`subcategory-${subcategory.uid}`}
                            checked={selectedCategory?.uid === subcategory.uid}
                            onChange={() => {
                                setSelectedCategory(subcategory);
                                console.log(selectedCategory)
                            }}

                            className="AddCheckedBoxes"
                        />
                        <label htmlFor={`subcategory-${subcategory.uid}`}>{subcategory.name}</label>
                    </div>
                ))}
            </div>
        );
    };


    useEffect(() => {
        fetchCategories();
        fetchSelectedSubCategories();
    }, []);


    const mainCategories = [
        {
            "_id": "686694202ac8d047299ea419",
            "uid": 1,
            "name": "Living Room",
            "slug": "bedroom"
        },
        {
            "_id": "686694482ac8d047299ea41c",
            "uid": 2,
            "name": "Bedroom",
            "slug": "berdroom"
        },
        {
            "_id": "6866946a2ac8d047299ea41f",
            "uid": 3,
            "name": "Dining Room",
            "slug": "dining-room",
        }
    ];


    const handleAddOrUpdate = async () => {
        const payload = {
            uid: selectedCategory?.uid,
            name: selectedCategory?.name,
            slug: selectedCategory?.slug,
            mainCategoryIds: selectedMainCategories
        };
        const apiCall = editId
            ? axios.put(`${DYRUrl}/api/v1/sub-category/sub-categories/${editId}`, payload)
            : axios.post(`${DYRUrl}/api/v1/sub-category/sub-categories`, payload);

        try {
            setLoading(true);
            await apiCall;
            setToastMessage(editId ? "Feature updated successfully!" : "Feature added successfully!");
            setSelectedCategory(null)
            setEditId(null);
            fetchSelectedSubCategories();
        } catch (error) {
            setToastMessage("An error occurred. Please try again.");
        } finally {
            setLoading(false);
            setShowMessage(true);
        }
    };

    return (
        <div className="dyr_base_comp">

            <div className="main_subcategories_dyr">
                <div className="left_side_subCat_dyr">
                    <h2>All Categories</h2>
                    <div className="sub_categories_list_dyr">
                        {
                            selectedSubCategories && selectedSubCategories.map((category) => {
                                return (
                                    <div className="subCat_dyr_tab">
                                        <div className="section_sdt">
                                            <div className="label_sdt">
                                                Uid
                                            </div>
                                            <div className="value_sdt">
                                                {category.uid}
                                            </div>
                                        </div>
                                        <div className="section_sdt">
                                            <div className="label_sdt">
                                                Name
                                            </div>
                                            <div className="value_sdt">
                                                {category.name}
                                            </div>
                                        </div>
                                        <div className="section_sdt">
                                            <div className="label_sdt">
                                                Slug
                                            </div>
                                            <div className="value_sdt">
                                                {category.slug}
                                            </div>
                                        </div>
                                        <div className="section_sdt">
                                            <div className="label_sdt">
                                                Main Category
                                            </div>
                                            <div className="value_sdt">
                                                {category?.mainCategoryIds && category?.mainCategoryIds?.length > 0 ? (
                                                    category.mainCategoryIds.map((cat, index) => (
                                                        <span style={{ background: "#0056b320", padding: "2px 4px", color: "#0056b3", borderRadius: "5px", marginRight: "2px", display: "inline-flex" }} key={index}>
                                                            {cat.name}
                                                        </span>
                                                    ))
                                                ) : (
                                                    "-"
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="right_side_subCat_dyr">
                    <h2>Add Category</h2>
                    <div className="main_categories_dyr">
                        {mainCategories.map((category) => {
                            const isSelected = selectedMainCategories.includes(category._id);

                            return (
                                <div
                                    key={category._id}
                                    onClick={() => {
                                        if (isSelected) {
                                            setSelectedMainCategories(prev =>
                                                prev.filter(id => id !== category._id)
                                            );
                                        } else {
                                            setSelectedMainCategories(prev => [...prev, category._id]);
                                        }
                                    }}
                                    className={isSelected ? "main_cat_com_dyr active" : "main_cat_com_dyr"}
                                >
                                    {category.name}
                                </div>
                            );
                        })}

                    </div>
                    <div className="all_categories_wp" style={{ width: "100%" }}>
                        <div className="category-list" style={{ width: "100%", maxHeight: "40vh" }}>
                            {categories &&
                                categories.map((category) => {
                                    // Check if this main category is already selected based on its UID matching 'parent' in selectedSubCategories
                                    const isDisabled = selectedSubCategories.some(
                                        (subCat) => subCat.parent === category.uid
                                    );

                                    return (
                                        <div key={category.uid} className="main-category">
                                            <div className="category-item-heading-update">
                                                <div className="category-main">
                                                    <input
                                                        type="checkbox"
                                                        disabled={isDisabled}
                                                        id={`main-category-${category.uid}`}
                                                        onChange={() => {
                                                            console.log(category)
                                                        }}
                                                    />
                                                    <label htmlFor={`main-category-${category.uid}`}>
                                                        {category.name}
                                                    </label>
                                                </div>
                                            </div>

                                            {renderSubcategories(category)}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>

                    <div className="SubmitBtn dyr">
                        {editId ? (
                            <>
                                <button
                                    type="button"
                                    className="dyr-cancel-btn"
                                    onClick={() => { handleAddOrUpdate() }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="dyr-submit-btn"
                                    onClick={() => { handleAddOrUpdate() }}
                                >
                                    Update
                                </button>
                            </>
                        ) : (
                            <button
                                type="button"
                                className="dyr-submit-btn"
                                onClick={() => { handleAddOrUpdate() }}
                            >
                                Add Category
                            </button>
                        )}
                    </div>


                </div>
            </div>
              <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => setShowMessage(false)}
            />

        </div>
    )
}